<!-- 検索フォーム -->
<template>
  <b-form @submit.prevent="submit" action="" class="w-100">
    <b-input-group :class="searchGroupClasses">
      <b-input-group-prepend
        is-text
        class="search-input-form search-prepend"
        size="sm"
        @click="onSearchPrependClicked"
      >
        <b-icon icon="search" />
      </b-input-group-prepend>
      <!-- 入力フォーム -->
      <b-form-input
        ref="searchForm"
        class="search-input-form w-100"
        :style="searchInputFormStyle"
        type="search"
        v-model="text"
        placeholder="検索"
        trim
        @change="onEnterKeyUp"
        @keyup.enter.native="onEnterKeyUp"
      ></b-form-input>
      <b-button type="submit" class="d-none" />
      <b-input-group-append
        v-if="text"
        is-text
        class="search-input-form search-append"
        @click="onSearchClearClicked"
      >
        <b-icon-x-circle-fill />
      </b-input-group-append>
    </b-input-group>
  </b-form>
</template>

<style scoped>
.search-input-form::-webkit-search-cancel-button {
  -webkit-appearance: none;
}

.search-input-form.search-append {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
</style>

<script lang="ts">
import { computed, defineComponent, getCurrentInstance, ref, watch } from "vue";
import type Vue from "vue";

export default defineComponent({
  name: "search-form",
  components: {},
  setup() {
    // $route / $router は Vue インスタンス経由（Step 3 で composable 化予定）
    const vm = getCurrentInstance()?.proxy as Vue | undefined;

    // 入力フォームへの参照（template の ref="searchForm" と一致させる）
    const searchForm = ref<HTMLInputElement | null>(null);

    // model
    const text = ref<string>("");

    // searchクエリが変わった場合に検索窓へ反映
    watch(
      () => vm?.$route.query.search,
      (search: string | (string | null)[] | null | undefined): void => {
        text.value = (search as string) || "";
      }
    );

    const searchGroupClasses = computed((): Record<string, boolean> => {
      return {
        "flex-nowrap": true,
        searching: !!text.value,
      };
    });

    const searchInputFormStyle = computed((): Record<string, string> => {
      // 検索文字列があるかどうかで角丸スタイルを変更する
      if (text.value) {
        return {};
      } else {
        return {
          "border-top-right-radius": "10px !important",
          "border-bottom-right-radius": "10px !important",
        };
      }
    });

    // 検索実行
    const submit = (search?: string | KeyboardEvent): void => {
      if (search != undefined && typeof search == "string") {
        text.value = search;
      }
      if (vm?.$root) {
        const searchQuery = vm.$route.query.search || "";
        if (searchQuery != text.value) {
          // historyに載せる
          const query = text.value ? { search: text.value } : {};
          vm.$router.push({ path: vm.$route.path, query: query });
        }
      }
    };

    // 虫眼鏡アイコンをクリックしたとき、検索窓にフォーカス入れる
    const onSearchPrependClicked = (): void => {
      const form = searchForm.value;
      if (form) {
        form.focus();
      }
    };

    // クリアボタン
    const onSearchClearClicked = (): void => {
      submit("");
    };

    const onEnterKeyUp = (): void => {
      if (!text.value) submit("");
    };

    // created 相当
    text.value = (vm?.$route?.query?.search as string) || "";

    return {
      searchForm,
      text,
      searchGroupClasses,
      searchInputFormStyle,
      submit,
      onSearchPrependClicked,
      onSearchClearClicked,
      onEnterKeyUp,
    };
  },
});
</script>
